module.exports = __webpack_public_path__ + "img/iso-9001.31e42610.png";